import {API_URL} from "./index";

export async function apiGetVersion() {
    const res = await fetch(`${API_URL}/version`);
    if (!res.ok) return null;
    return res.json();
}
